import { updates } from "@/mocks/homeData";

export default function UpdatesSection() {
  return (
    <section id="updates" className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            每日更新
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            实时同步最新剧集上线动态，追剧快人一步
          </p>
        </div>

        <div className="max-w-[900px] mx-auto">
          <div className="relative pl-8 md:pl-10">
            <div className="absolute left-3 md:left-4 top-1 bottom-1 w-[2px] bg-background-300" />

            <div className="space-y-5">
              {updates.map((item) => (
                <div key={item.id} className="relative">
                  <div
                    className={`absolute -left-[25px] md:-left-[30px] top-1.5 w-[14px] h-[14px] rounded-full border-2 ${
                      item.tag === "今日更新"
                        ? "border-accent-500 bg-accent-500"
                        : "border-background-300 bg-background-50"
                    }`}
                  />

                  <div className="flex flex-col sm:flex-row sm:items-start gap-1.5 sm:gap-3">
                    <div className="flex items-center gap-2 shrink-0">
                      <span className="text-xs text-foreground-500 whitespace-nowrap">
                        {item.date}
                      </span>
                      <span
                        className={`text-[11px] font-medium px-2 py-0.5 rounded whitespace-nowrap ${
                          item.tag === "今日更新"
                            ? "bg-accent-100 text-accent-700"
                            : item.tag === "昨日更新"
                              ? "bg-secondary-100 text-secondary-700"
                              : "bg-primary-50 text-primary-700"
                        }`}
                      >
                        {item.tag}
                      </span>
                    </div>
                    <p className="text-sm text-foreground-800 leading-relaxed">
                      {item.title}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}